<template>
	<div>
		<a-spin :spinning="loading" tip="logining..">
			<div style="height: 100vh; width: 100%;"></div>
		</a-spin>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				loading:false
			}
		},
		created(){
			let shop_token =  this.$route.query.shop_token;
			// let shop_token = 'e3701PMTsA/s8ybmZ6u/b1f8bM3D2OufuH4WacOi6R7Su1C/lLJ0voRTQp6o2LulRR1/3xxM0AneRE335+DeI/j/';
			//console.log(shop_token);
			if(!shop_token){
				//location.href = process.env.VUE_APP_ACCOUNT_URL+'/mendian';
				location.href = process.env.VUE_APP_BASE_API + '/beautiful#/merchant/login';
			}else{
				
				this.$http.papi('platform/authLogin',{
					token:shop_token
				}).then(res=>{
					localStorage.setItem('beautiful-token',shop_token);
					this.$router.push('/index');
				}).catch(res=>{
					console.log('授权超时')
				});	
			}
		},
		methods:{
			
		}
	}
</script>

<style>
	
</style>